module.exports = __webpack_public_path__ + "img/PRINCESS.5a9f9612.png";